export const Loginapi = ({ form, BeURL, setIsAuth, setCurrentUser, fingerPrintId, browserName, ipAddress, setLoading, navigate, setLogin,showAlert}) => {
    fetch(`${BeURL}/signin`, {
        method: 'POST',
        credentials : 'include',
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ email: form.email, password: form.password, fingerPrintId, browserName, ipAddress })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success) {
                setIsAuth(true)
                setCurrentUser(data.user)
                setLoading(true) 
                setLogin(true)               
                navigate('/')  
                showAlert(data.message)                        
            }
            else {
                showAlert(data.message)
            }
        })
        .catch(err => {
           
            console.log('Error in Login:', err)
            alert('Trouble in connecting to the Server! Please try again later.')
        })
        .finally(() => {
            setLoading(false); // Always stop loading at the end
        });
}


